import * as React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import InvoiceDetail from '../InvoiceDetail/InvoiceDetail';
import { Operation } from '../../../../const/CancelModel';
import PaymentOptions from '../paymentOptions/PaymentOptions';
import { Checkbox } from 'react-bootstrap';
import './informationCancel.css';


const propTypes = {
	afterCancel: PropTypes.any,
	data: PropTypes.any,
	cancelSimulateModel: PropTypes.any,
	azulNumber: PropTypes.any
};


class InformationCancel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			isRedirect: false,
			urlRedirect: ''
		};
	}

	render() {
		const model = this.props.cancelSimulateModel;
		return (
			<div data-test="infoCancel">
				<Row className="margin-eight-top-24">
					<InvoiceDetail
						data-unit="invoiceDetail"
						balanceColor={this.getBalanceColor(model.simulation)}
						data={model}
					/>
				</Row>
				{this.renderCheckBox()}
				<Row className="margin-eight-top-24">
					<PaymentOptions
						data-unit="paymentOptions"
						cancelModel={model}
						radios={this.getRadioOptions(model.simulation)}
						azulNumber={this.props.azulNumber}
						termIsChecked={this.state.termIsChecked}
					/>
				</Row>
			</div>
		);
	}

	renderCheckBox() {
		return (
			<Row>
				<Col xs={24} sm={24} className="InformationCancel__colCheckbox">
					<div
						className={`InformationCancel__checkbox ${this.state.termIsChecked ? 'checked' : ''
							}`}>
						<Checkbox
							id="ckBxTerm"
							bsClass={`checkbox InformationCancel__checkbox--input ${this.state.termIsChecked ? 'checked' : ''
								}`}
							onChange={() => {
								this.setAgreeCancellationTerms();
							}}
							checked={this.state.termIsChecked}
						/>
						<label className="FlightsSearchPage__checkbox--text">
							{i18n.translate('context.cancelPnrPage.termAccept')}
						</label>
					</div>
				</Col>
			</Row>
		)
	}

	getRadioOptions(simulateResponse) {
		const options = new Array();
		if (simulateResponse.operation === Operation.REFUND || simulateResponse.operation === Operation.REFUND_FREE) {
			options.push(i18n.translate('context.cancelPnrPage.paymentOption.refundClient'));
		} else if (simulateResponse.operation === Operation.PAYMENT || simulateResponse.operation === Operation.PAYMENT_FREE || simulateResponse.operation === Operation.NOT_OPERATION) {
			options.push(i18n.translate('context.cancelPnrPage.paymentOption.payWithCreditCard'));
			options.push(i18n.translate('context.cancelPnrPage.paymentOption.refundTax'));
		}
		return options;
	}

	getBalanceColor(simulateResponse) {
		return simulateResponse.operation === Operation.PAYMENT || simulateResponse.operation === Operation.PAYMENT_FREE ? 'red' : 'blue-2';
	}

	setAgreeCancellationTerms = () => {
		let termIsChange = !this.state.termIsChecked;
		this.setState({
			termIsChecked: termIsChange
		});
	};
}

InformationCancel.propTypes = propTypes;

export default InformationCancel;



// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/informationCancel/InformationCancel.jsx